export default class FormDonation {
  constructor(element) {
    this.donationtypes = element.querySelectorAll('ul.js-donationtype input')
    if (!this.donationtypes) {
      return
    }

    this.customAmountFields = element.querySelectorAll('.valKies_zelf_een_bedrag')
    if (!this.customAmountFields) {
      return
    }

    // On nextstep click:
    element.querySelector('.js-nextsteptrigger').addEventListener('click', (event) => this.nextStep(event))

    // On submit click:
    element.querySelector('input.js-submit').addEventListener('click', (event) => this.submitButtonClick(event))

    this.element = element

    this.init()
  }

  isOtheramountValid() {
    let otherAmountSelected = this.element.querySelector(
      '.is--active .js-amountchoice .valKies_zelf_een_bedrag input:checked'
    )

    if (otherAmountSelected) {
      let otherAmountSelectedValue = this.element.querySelector('.js-customvalue input.js-customvalue').value
      let minAllowedValue = this.element.querySelector('.is--active .js-amountchoice li input').value

      if (Number(otherAmountSelectedValue) < Number(minAllowedValue)) {
        this.element.querySelector('.js-customamounterror').classList.add('is--active')
        document.getElementById('customamounterror').scrollIntoView({ behavior: 'smooth', block: 'center' })
        return false
      } else {
        this.element.querySelector('.js-customamounterror').classList.remove('is--active')
        return true
      }
    } else {
      this.element.querySelector('.js-customamounterror').classList.remove('is--active')
      return true
    }
  }

  submitButtonClick(event) {
    event.preventDefault()

    if (this.isOtheramountValid() && this.validateNawFields()) {
      const submitButton = this.element.querySelector('input.js-submit')
      submitButton.disabled = true
      submitButton.value = 'Wordt verzonden...'

      window.dataLayer.push({
        event: 'donatie',
        stap: 'stap 2',
        stap_naam: 'voltooid',
        donatie_type: this.element.querySelector('input[name="DonationType"]:checked').value,
      })

      this.element.querySelector('.js-donation-form > form').submit()
    } else {
      let errorInputs = this.element.querySelectorAll('.js-error input')

      errorInputs[0].closest('.field').scrollIntoView({ behavior: 'smooth', block: 'center' })

      errorInputs.forEach((el) => {
        el.addEventListener('change', () => {
          this.validateNawFields()
        })
      })
    }
  }

  nextStep() {
    window.dataLayer.push({
      event: 'donatie',
      stap: 'stap 1',
      stap_naam: 'bedrag',
      donatie_type: this.element.querySelector('input[name="DonationType"]:checked').value,
    })

    if (this.isOtheramountValid()) {
      this.element.querySelector('.js-nextsteptrigger').classList.add('hidden')

      const nextstep = this.element.querySelector('.js-formsection--naw')
      nextstep.classList.add('is--active')

      document.getElementById('NAW').scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  validateNawFields() {
    let validation = true

    // Reset all error classes:
    let oldErrorClasses = this.element.querySelectorAll('.js-error')

    oldErrorClasses.forEach((el) => {
      el.classList.remove('js-error')
    })

    // All required text fields:
    const requiredTextFields = this.element.querySelectorAll('.js-formsection--naw .field.text.is--required input')
    requiredTextFields.forEach((el) => {
      if (!el.value) {
        validation = false

        el.closest('.field').classList.add('js-error')
      }
    })

    // All required checkboxes:
    const requiredCheckFields = this.element.querySelectorAll('.js-formsection--naw .field.checkbox.is--required input')
    requiredCheckFields.forEach((el) => {
      if (!el.checked) {
        validation = false

        el.closest('.field').classList.add('js-error')
      }
    })

    // Custom zipcode validation
    const requiredZipcodeField = this.element.querySelector(
      '.js-formsection--naw .field.js-validate-zipcode.is--required input.js-validate-zipcode'
    )
    if (requiredZipcodeField) {
      const zipcodeRegEx = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i

      if (!zipcodeRegEx.test(requiredZipcodeField.value)) {
        validation = false

        requiredZipcodeField.closest('.field').classList.add('js-error')
      }
    }

    // Custom email validation
    const requiredEmailField = this.element.querySelector(
      '.js-formsection--naw .field.js-validate-email.is--required input.js-validate-email'
    )
    if (requiredEmailField) {
      const emailRegEx =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      if (!emailRegEx.test(requiredEmailField.value)) {
        validation = false

        requiredEmailField.closest('.field').classList.add('js-error')
      }
    }

    if (validation) {
      return true
    } else {
      return false
    }
  }

  init() {
    if (
      this.element.querySelector('.message.required') &&
      !this.element.querySelector('.js-nextsteptrigger').classList.contains('hidden')
    ) {
      this.nextStep()
    }

    this.donationtypes.forEach((donationtype) => {
      donationtype.addEventListener('click', () => {
        let donationtype = this.element.querySelector('input[name="DonationType"]:checked').value

        const companynamefield = this.element.querySelector('.js-togglefield')
        const companynamefieldIinput = this.element.querySelector('.js-togglefield .js-togglefield')
        const privatefields = this.element.querySelector('.js-donationtypeprivate')
        const businessfields = this.element.querySelector('.js-donationtypepbusiness')

        if (donationtype == 'Prive') {
          privatefields.classList.remove('hidden')
          businessfields.classList.add('hidden')

          companynamefieldIinput.classList.add('hidden', 'is--required')
          companynamefield.classList.add('hidden', 'is--required')
          companynamefieldIinput.classList.remove('is--required')
          companynamefield.classList.remove('is--required')

          // Reset other amount:
          let currentCustomValue = privatefields.querySelector('input.customamoundfield').value
          this.element.querySelector('input.js-customvalue').value = currentCustomValue
        } else {
          privatefields.classList.add('hidden')
          businessfields.classList.remove('hidden')

          companynamefieldIinput.classList.remove('hidden')
          companynamefield.classList.remove('hidden')
          companynamefieldIinput.classList.add('is--required')
          companynamefield.classList.add('is--required')

          // Reset other amount:
          let currentCustomValue = businessfields.querySelector('input.customamoundfield').value
          this.element.querySelector('input.js-customvalue').value = currentCustomValue
        }
      })
    })

    this.customAmountFields.forEach((customAmountField) => {
      const newInputElement = document.createElement('input')
      newInputElement.type = 'number'
      newInputElement.min = '1'
      newInputElement.autocomplete = 'off'
      newInputElement.placeholder = 'vul in'
      newInputElement.classList.add('customamoundfield')

      customAmountField.append(newInputElement)

      customAmountField.addEventListener('click', (event) => {
        newInputElement.focus()
      })

      newInputElement.addEventListener('keydown', (event) => {
        if (event.key == 'Enter' && !this.element.querySelector('.js-nextsteptrigger').classList.contains('hidden')) {
          event.preventDefault()
          this.nextStep()
        }
        // Verboden chars:
        if (event.key == '-' || event.key == 'e' || event.key == 'E' || event.key == '.') {
          event.preventDefault()
        }
      })

      newInputElement.addEventListener('mousewheel', (event) => {
        event.preventDefault()
        this.element.blur()
      })

      newInputElement.addEventListener('input', () => {
        this.element.querySelector('input.js-customvalue').value = newInputElement.value
      })

      addEventListener('paste', (event) => {
        event.preventDefault()
      })
    })
  }
}
